import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";



export interface IGroupParam {
    id: number
    title: string
    name: string
    sortOrder: number
    params: Param[]
}

export interface Param {
    id: number
    code: string
    name: string
    fieldCode: string
    fieldLabel: string
    sortOrder: number
    is_active: boolean
}

export interface IInfoSystemParam {
    id: number
    code: string
    name: string
    status: number
    groups: Group[]
}

export interface Group {
    id: number
    title: string
}


export const swapParameters = async (
    recordId : number, listFields?: number[]
) => {
    const path = "/systemParam/swapParameters"
    const params = {
        recordId, listFields
    }
    const result: ResponseSuccess<[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const getListCustomerRecords = async (
    limit?: number, pageNumber?: number
) => {
    const path = "/profileCustomer/listCustomerRecords"
    const params = {
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<Group[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getListGroupParam = async (
    search?: string
) => {
    const path = "/systemParam/listGroupParam"
    const params = {
        search
    }
    const result: ResponseSuccessTotal<IGroupParam[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const getInfoSystemParam = async (
    code?: string
) => {
    const path = "/systemParam/infoSystemParam"
    const params = {
        code
    }
    const result: ResponseSuccessTotal<IInfoSystemParam> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const activeParameters = async (
    code: string
) => {
    const path = "/systemParam/activeParameters"
    const params = {
        code
    }
    const result: ResponseSuccess<IInfoSystemParam> = await axiosClient.put(
        path, params
    );
    return result;
};

export const editSystemParam = async (
    code: string, name: string, groupId: number[], status: number
) => {
    const path = "/systemParam/editSystemParam"
    const params = {
        code, name, groupId, status
    }
    const result: ResponseSuccess<IInfoSystemParam> = await axiosClient.put(
        path, params
    );
    return result;
};


export const addSystemParam = async (
    code: string, name: string, groupId: number[], status: number
) => {
    const path = "/systemParam/addSystemParam"
    const params = {
        code, name, groupId, status
    }
    const result: ResponseSuccess<IInfoSystemParam> = await axiosClient.post(
        path, params
    );
    return result;
};
